module.exports = __webpack_public_path__ + "static/media/abacus.e1adb874.png";